import { Injectable, inject } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { AsyncOutputJob, ImprimoPreviewService } from '@elderbyte/ngx-imprimo'
import { ElderToastService } from '@elderbyte/ngx-starter'
import { Observable } from 'rxjs'
import { NewReportJob, ReportSpec } from '../report/report-job'
import { ReportJobService } from '../report/report-job.service'

@Injectable({
  providedIn: 'root',
})
export class OutputPreviewService {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly reportJobService = inject(ReportJobService)
  private readonly previewService = inject(ImprimoPreviewService)
  private readonly toastService = inject(ElderToastService)

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public openPreviewDialog(reportSpec: ReportSpec): void {
    this.createPreviewJob(reportSpec).subscribe({
      next: (asyncJob) => this.openPreviewDialogInternal(asyncJob),
      error: (err) => this.toastService.error('Failed to create preview job!', err),
    })
  }

  /***************************************************************************
   *                                                                         *
   * Private methods                                                         *
   *                                                                         *
   **************************************************************************/

  private createPreviewJob(reportSpec: ReportSpec): Observable<AsyncOutputJob> {
    return this.reportJobService.createAsync(NewReportJob.preview(reportSpec))
  }

  private openPreviewDialogInternal(previewJob: AsyncOutputJob): MatDialogRef<any> {
    return this.previewService.openPreviewDialog({
      asyncJob: previewJob,
    })
  }
}
